import { ColumnType } from "../../constants/schema.js";
import { arrayHas } from "../arrayHas.js";
import { ColumnTypeShown, isLogicalNameView } from "../../engine/modules/editor/utils/nameView.js";
import { CLIPBOARD_FORMAT, CLIPBOARD_HTML_ATTR, CLIPBOARD_HTML_TRUNCATED_ATTR, CLIPBOARD_MIME, HTML_PAYLOAD_MAX_BYTES, PayloadKind, createPayload, migratePayload, parsePayload } from "./payload.js";
import { resolvePlacement } from "./placement.js";
//#region src/utils/table-clipboard/index.ts
var CellType = {
	columnName: "columnName",
	columnDataType: "columnDataType",
	columnNotNull: "columnNotNull",
	columnUnique: "columnUnique",
	columnAutoIncrement: "columnAutoIncrement",
	columnDefault: "columnDefault",
	columnComment: "columnComment",
	columnLogicalName: "columnLogicalName",
	columnDomain: "columnDomain"
};
var hasCellType = arrayHas(Object.values(CellType));
function getShowColumnOrder(show, columnOrder, nameViewMode) {
	const settings = {
		show,
		nameViewMode
	};
	const logical = isLogicalNameView(settings);
	return columnOrder.filter((columnType) => ColumnTypeShown[columnType]?.(settings) === true).map((columnType) => logical && columnType === ColumnType.columnName ? ColumnType.columnLogicalName : columnType);
}
//#endregion
export { CLIPBOARD_FORMAT, CLIPBOARD_HTML_ATTR, CLIPBOARD_HTML_TRUNCATED_ATTR, CLIPBOARD_MIME, CellType, HTML_PAYLOAD_MAX_BYTES, PayloadKind, createPayload, getShowColumnOrder, hasCellType, migratePayload, parsePayload, resolvePlacement };
